import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { relationshipSteps } from '@/mocks/about';

export default function Relationship() {
  return (
    <section id="relationship" className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            dark
            title="华辉数智 × 九畴云市"
            en="Company & Project"
            subtitle="华辉数智技术是技术服务主体，九畴云市是核心战略项目——华辉数智承担九畴云市核心技术系统的研发、交付与系统集成。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5 items-stretch">
          {relationshipSteps.map((step, i) => (
            <Reveal key={step.title} delay={i * 120}>
              <div
                className={`relative h-full p-6 rounded-lg border text-center ${
                  i === 1
                    ? 'bg-primary-500/10 border-primary-500/40'
                    : 'bg-foreground-900 border-foreground-700'
                }`}
              >
                <div className="w-14 h-14 mx-auto rounded-full bg-accent-500/20 flex items-center justify-center">
                  <i className={`${step.icon} text-accent-300 text-2xl`}></i>
                </div>
                <h3 className="mt-4 font-heading font-bold text-lg text-background-50">
                  {step.title}
                </h3>
                <div className="mt-1 text-xs text-primary-300 whitespace-nowrap">{step.sub}</div>
                <p className="mt-3 text-sm text-foreground-300 leading-relaxed">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}